import React from "react";
import "./Cover.css";

function Cover() {
  return (
    <div className="cover">
      <div className="cover__text container">
        <h3>
          DISCOVER EVENTS <br /> FOR ALL THE THINGS <br /> YOU LOVE.
        </h3>
      </div>
    </div>
  );
}

export default Cover;
